
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import gateway from "@/lib/request/gateway";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import UploadLoading from "./upload-loading.vue";

@Component({
  components: { UploadLoading }
})
export default class Mp3Upload extends Vue {
  @Prop({ type: QuestionV2, default: null }) question!: QuestionV2; //题目model

  showMore = true; //维度展开
  filename = "";
  fileUrl = "";
  options: string[] = [];
  radio = 0;
  score = 1;
  useMp3 = false;
  audioTime = 0;
  isLoading = false;

  created() {
    if (!this.question) return;
    this.filename = this.question.audioDescFilename;
    this.fileUrl = this.question.audioDescUrl;
    this.radio = this.question.audioDescPlayTimeLimit === 0 ? 0 : 1;
    this.score =
      this.question.audioDescPlayTimeLimit === 0
        ? 1
        : this.question.audioDescPlayTimeLimit;
    this.audioTime = this.question.audioDescDuration;
    if (this.question.isAudioDescAutoPlay === 1) {
      this.options.push("isAudioDescAutoPlay");
    }
    if (this.question.isAudioDescForbidPause === 1) {
      this.options.push("isAudioDescForbidPause");
    }
    if (this.question.isAudioDescMustPlay === 1) {
      this.options.push("isAudioDescMustPlay");
    }
  }

  get token() {
    return Auth.token;
  }

  changeMore() {
    this.showMore = !this.showMore;
  }

  delAudio() {
    this.filename = "";
    this.fileUrl = "";
    this.audioTime = 0;
  }

  uploadMp3(data: { filename: string; file: File }) {
    const { file } = data;
    const isMP3 = file.name.split(".")[1] === "mp3";
    const isLt5M = file.size < 1024 * 1024 * 5;
    // 上传图片到oss
    if (!isMP3) {
      this.$message.error("上传图片只能是 MP3 格式!");
      return;
    }
    if (!isLt5M) {
      this.$message.error("上传音频过大!");
      return;
    }
    this.filename = file.name;
    this.isLoading = true;
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway.upload(postRes, file).then((res: any) => {
          this.fileUrl = tempUrl;
          this.getAudioTime(tempUrl);
          this.isLoading = false;
        });
      }
    });
  }

  getAudioTime(url: string) {
    const audio = new Audio();
    audio.src = url;
    const countAudioTime = async () => {
      while (isNaN(audio.duration) || audio.duration === Infinity) {
        await new Promise(resolve => setTimeout(resolve, 200));
        audio.currentTime = 10000 * Math.random();
      }
      this.audioTime = audio.duration;
    };
    countAudioTime();
  }

  getMp3Info() {
    const times = this.radio === 0 ? 0 : this.score;
    const mp3Info = {
      audioDescUrl: this.fileUrl, // 文件url
      audioDescFilename: this.filename, // 文件名
      auditDescDuration: this.audioTime, // 时长
      audioDescPlayTimeLimit: times, // 播放次数限制
      isAudioDescAutoPlay: this.options.includes("isAudioDescAutoPlay") ? 1 : 2, // 是否读题后自动播放
      isAudioDescMustPlay: this.options.includes("isAudioDescMustPlay") ? 1 : 2, // 是否强制播放
      isAudioDescForbidPause: this.options.includes("isAudioDescForbidPause")
        ? 1
        : 2 // 是否禁止暂停
    };
    return mp3Info;
  }
}
